/* Printies - Build a Box: value banner + pack goal + Random Fill + category sections.
   Front-end only (EBB's dashboard iframe can't be automated). Re-binds after re-renders. */
(function () {
  "use strict";
  if (!/\/apps\/gbb\//.test(location.pathname)) return;

  var TIERS = [
    { n: 6, price: "$21.99" },
    { n: 15, price: "$29.99" },
    { n: 30, price: "$34.99" },
    { n: 50, price: "$44.99", gift: "Includes Mystery Gift" }
  ];
  var MYSTERY = "random printie"; // builder shows "Random Printie | Default"
  var CATS = [
    ["classic", "The Classic Collection"],
    ["ocean", "Ocean Friends"],
    ["wild", "Wild Friends"],
    ["dogs", "Dogs & Pups"],
    ["cats", "Cats & Kittens"],
    ["dinos", "Dinos"],
    ["bugs", "Bugs & Critters"],
    ["farm", "Farmyard"],
    ["fantasy", "Fantasy & Legends"],
    ["spooky", "Spooky"],
    ["christmas", "Christmas"],
    ["space", "Outer Space"]
  ];
  var CATMAP = {"alien cat":"cats","alien skeleton":"spooky","alien":"space","angel":"christmas","angry chameleon":"wild","astronaut":"space","axolotl":"ocean","bat":"spooky","beaver":"wild","bee":"bugs","big-eye bee":"bugs","big-eye hedgehog":"wild","big-eye penguin":"wild","bigfoot":"spooky","bone dog":"spooky","boy bunny":"wild","brontosaurus skeleton":"dinos","brontosaurus":"dinos","brown bear":"wild","bunny skeleton":"spooky","bunny":"wild","butterfly fish":"ocean","camel":"farm","capybara":"wild","cardinal":"wild","carrot":"fantasy","cat guy":"cats","cat":"cats","caterpillar":"classic","celestial dragon":"fantasy","chameleon":"wild","chef mouse":"wild","chick":"farm","chicken":"farm","chill crocodile":"wild","chihuahua":"dogs","christmas krampus":"christmas","clown fish":"ocean","corgi":"dogs","crocodile":"wild","crow":"spooky","cthulhu":"spooky","dachshund":"dogs","demon":"spooky","dog":"classic","dolphin":"ocean","dotted seal":"ocean","dracula":"spooky","dragon fruit":"fantasy","dragon":"fantasy","duck":"farm","dumbo octopus":"ocean","eagle":"wild","egg":"fantasy","elephant":"classic","farm cow":"farm","flat hammerhead":"ocean","fox":"classic","frog":"wild","gingerbread":"christmas","giraffe":"wild","gnome":"fantasy","goat":"farm","goblin":"fantasy","golden dragon":"fantasy","grinch":"christmas","halloween crows":"spooky","halloween skeleton cat":"spooky","halloween skeleton":"spooky","hammerhead":"ocean","hamster":"wild","heart":"fantasy","hedgehog":"wild","hermit crab":"ocean","highland cow":"farm","hippo":"wild","horse":"farm","hot dog dog":"dogs","husky":"dogs","creepy clown":"spooky","iguana":"wild","jumping spider":"bugs","killer whale":"ocean","koala":"wild","koi fish":"ocean","ladybird spider":"bugs","ladybug":"bugs","lazy dog":"dogs","lazy duck":"farm","lazy elephant":"wild","lazy husky":"dogs","leopard gecko":"wild","lion":"wild","lizard":"wild","lobster":"ocean","lucky clover skeleton":"spooky","manatee":"classic","mini cat":"classic","mini panda":"wild","moai":"fantasy","monkey":"wild","mothman":"spooky","mouse":"wild","mr. skeleton":"spooky","mummy":"spooky","narwhal":"classic","nessie":"ocean","octopus":"ocean","opossum":"wild","otter (face down)":"ocean","otter (face up)":"ocean","owl":"wild","panda":"wild","penguin":"classic","pig":"classic","platypus":"ocean","polar bear":"wild","pterodactyl skeleton":"dinos","pterodactyl":"dinos","puffer fish":"ocean","pug":"dogs","pumpkin skeleton":"spooky","pumpkin":"classic","rabbit":"wild","raccoon":"wild","red lobster":"ocean","reindeer":"christmas","rhino":"wild","robot":"space","rock":"fantasy","rottweiler":"dogs","santa claus":"christmas","santa hat skeleton":"christmas","schnauzer":"dogs","scorpion":"bugs","seal":"ocean","shark":"ocean","sheep":"farm","shrimp":"ocean","skeleton astronaut":"spooky","skeleton":"spooky","skunk":"wild","sleepy cat":"cats","sloth":"wild","snail":"bugs","snoopy":"dogs","snowman":"christmas","spider":"bugs","squirrel":"wild","starfish":"ocean","stegosaurus skeleton":"dinos","stegosaurus":"dinos","stitch":"fantasy","summer skeleton":"spooky","surgeon fish":"ocean","t-rex":"dinos","tiger":"wild","triceratops skeleton":"dinos","triceratops":"dinos","turtle":"ocean","unicorn":"classic","valentine bear":"fantasy","water dragon":"fantasy","werewolf":"spooky","whale":"ocean","witch":"spooky","wolf":"wild","zebra":"wild","zombie":"spooky"};
  var goal = null;
  var filling = false;

  function norm(s) { return (s || "").trim().toLowerCase().replace(/\s*\|\s*default$/, "").trim(); }
  function isMystery(title) { return norm(title).indexOf(MYSTERY) === 0; }
  function catOf(title) { return CATMAP[norm(title)] || "more"; }

  function count() {
    var f = document.querySelector(".gbbBundleFooter");
    if (!f) return 0;
    var m = f.innerText.match(/(\d+)\s*item/i);
    return m ? parseInt(m[1], 10) : 0;
  }

  function tileTitle(it) {
    var t = it.querySelector(".gbbProductTitle");
    return t ? t.textContent : "";
  }

  function mysteryTile() {
    return [].slice.call(document.querySelectorAll(".gbbProductItem")).find(function (it) {
      return isMystery(tileTitle(it));
    });
  }

  function addOneMystery() {
    var tile = mysteryTile();
    if (!tile) return false;
    var btn = tile.querySelector(".gbbQuantityStepperAddButton") ||
              tile.querySelector(".gbbProductAddButton");
    if (btn) { btn.click(); return true; }
    return false;
  }

  function hideMysteryTile() {
    var t = mysteryTile();
    if (t) t.classList.add("pt-hidden-tile");
  }

  // Group the product tiles under category headers (Classic first, then themes).
  function groupTiles() {
    var first = document.querySelector(".gbbProductItem");
    if (!first || !first.parentElement) return;
    var grid = first.parentElement;
    if (grid.querySelector(".pt-cat-head")) return; // already grouped; app hasn't reset it
    var tiles = [].slice.call(grid.querySelectorAll(".gbbProductItem"));
    if (tiles.length < 5) return; // pool not fully rendered yet
    var byCat = {};
    tiles.forEach(function (it) {
      if (isMystery(tileTitle(it))) return; // mystery stays hidden, not in a section
      var c = catOf(tileTitle(it));
      (byCat[c] = byCat[c] || []).push(it);
    });
    var headStyle = "grid-column:1/-1;font-size:1.1rem;font-weight:700;color:#2e2e38;" +
      "letter-spacing:-.01em;padding:20px 2px 8px;border-bottom:2px solid rgba(61,123,232,.25);" +
      "margin:10px 0 2px;";
    var order = CATS.slice();
    order.push(["more", "More Friends"]);
    order.forEach(function (pair) {
      var list = byCat[pair[0]];
      if (!list || !list.length) return;
      var head = document.createElement("div");
      head.className = "pt-cat-head";
      head.style.cssText = headStyle;
      head.textContent = pair[1] + "  (" + list.length + ")";
      grid.appendChild(head);
      list.forEach(function (it) { grid.appendChild(it); });
    });
  }

  function setGoal(n) {
    goal = n;
    document.querySelectorAll(".pt-tier").forEach(function (b) {
      b.classList.toggle("is-active", parseInt(b.getAttribute("data-n"), 10) === n);
    });
    renderGoal();
  }

  function renderGoal() {
    var box = document.querySelector(".pt-goal");
    if (!box) return;
    var c = count();
    var countEl = box.querySelector(".pt-goal__count");
    var bar = box.querySelector(".pt-goal__bar span");
    var fill = box.querySelector(".pt-fill");
    if (!goal) {
      countEl.textContent = "Pick a pack size";
      if (bar) bar.style.width = "0%";
      fill.disabled = true;
      fill.textContent = "Choose a pack size above";
      return;
    }
    countEl.textContent = c + " / " + goal;
    if (bar) bar.style.width = Math.min(100, Math.round((c / goal) * 100)) + "%";
    var remaining = Math.max(0, goal - c);
    fill.disabled = filling || remaining === 0;
    fill.textContent = filling ? "Filling your box..."
      : (remaining === 0 ? "Pack full" : "Random Fill (" + remaining + " to go)");
  }

  // --- Category-aware Random Fill -------------------------------------------
  // The Random Printie tile only exists in the DOM when the category that owns
  // it (Classic) is the active tab. So if the shopper triggers Random Fill from
  // any other category, hop to Classic to do the adds, then hop back.
  function catTitleEls() {
    return [].slice.call(document.querySelectorAll(".gbbCategoryTabTitle"));
  }
  function activeCatText() {
    var c = [].slice.call(document.querySelectorAll(".gbbCategoryTabContainer")).find(function (x) {
      var m = getComputedStyle(x).backgroundColor.match(/\d+/g); // active tab has a dark fill
      return m && (parseInt(m[0], 10) + parseInt(m[1], 10) + parseInt(m[2], 10)) < 382;
    });
    var t = c && c.querySelector(".gbbCategoryTabTitle");
    return t ? t.textContent.trim() : null;
  }
  function clickCatByText(re) {
    var el = catTitleEls().find(function (t) { return re.test(t.textContent.trim()); });
    if (el) { el.click(); return true; }
    return false;
  }
  function waitFor(pred, timeout, cb) {
    var start = Date.now();
    (function loop() {
      if (pred()) return cb(true);
      if (Date.now() - start > timeout) return cb(false);
      setTimeout(loop, 100);
    })();
  }
  // While filling we may hop to Classic to reach the Mystery tile. EBB animates
  // the pool's opacity (so CSS opacity can't hide it) - instead cover the builder
  // with an OPAQUE panel showing live progress. CRITICAL: the panel lives on
  // document.body (NOT inside the wrapper our MutationObserver watches) - a cover
  // inside the observed tree makes every progress-text update retrigger our
  // rebuild and grind the fill to a crawl. The hop happens unseen beneath it.
  function ensureMaskStyle() {
    if (document.getElementById("pt-fill-style")) return;
    var s = document.createElement("style");
    s.id = "pt-fill-style";
    s.textContent =
      ".pt-fill-cover{position:absolute;background:#fffdf8;z-index:9999;" +
      "display:flex;align-items:center;justify-content:center;text-align:center;" +
      "font-weight:700;color:#3d7be8;font-size:1.15rem;letter-spacing:.01em}";
    document.head.appendChild(s);
  }
  function bundleWrap() {
    return document.querySelector(".gbbBundleWrapper") || document.querySelector(".gbbFullPageBundle");
  }
  function coverEl() { return document.querySelector(".pt-fill-cover"); }
  function coverText(c) {
    return "Filling your box" + (goal ? "  " + c + " / " + goal : "") + "...";
  }
  function showMask() {
    ensureMaskStyle();
    var w = bundleWrap();
    if (!w || coverEl()) return;
    var r = w.getBoundingClientRect();
    var o = document.createElement("div");
    o.className = "pt-fill-cover";
    o.style.top = (r.top + window.scrollY) + "px";
    o.style.left = (r.left + window.scrollX) + "px";
    o.style.width = r.width + "px";
    o.style.height = r.height + "px";
    o.textContent = coverText(count());
    document.body.appendChild(o);
  }
  function updateCover(c) { var o = coverEl(); if (o) o.textContent = coverText(c); }
  function hideMask() { var o = coverEl(); if (o) o.remove(); }

  function unavailable() {
    filling = false;
    hideMask();
    renderGoal();
    alert("Random Fill isn't available yet - the Random Printie isn't in this bundle's product list.");
  }

  function finishFill(returnTo) {
    if (returnTo && !/classic/i.test(returnTo)) {
      clickCatByText(new RegExp("^" + returnTo.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "$", "i"));
    }
    // keep the cover up briefly so the hop-back renders unseen, then reveal
    setTimeout(function () { filling = false; hideMask(); renderGoal(); }, 300);
  }

  // Simple fast add loop (observer is paused, so no thrash). Stops as soon as the
  // footer count reaches the goal; a stray click can't overshoot the top-of-tick
  // guard by more than one, which EBB caps at the goal anyway.
  function runFill(returnTo) {
    var guard = 0;
    (function tick() {
      var c = count();
      updateCover(c);
      if (c >= goal || guard > 500) { finishFill(returnTo); return; }
      guard++;
      addOneMystery();
      setTimeout(tick, 150);
    })();
  }

  function mysteryFill() {
    if (filling || !goal) return;
    filling = true;
    renderGoal();
    var origCat = activeCatText();
    showMask();
    if (mysteryTile()) { runFill(origCat); return; }      // already on a category that has it
    if (!clickCatByText(/classic/i)) { unavailable(); return; }
    waitFor(function () { return !!mysteryTile(); }, 4000, function (ok) {
      if (!ok) { unavailable(); return; }
      runFill(origCat);
    });
  }

  function buildBanner() {
    var wrap = document.querySelector(".gbbBundleWrapper") ||
               document.querySelector(".gbbFullPageBundle");
    if (!wrap || wrap.querySelector(".pt-banner")) return;
    var tiers = TIERS.map(function (t) {
      return '<button type="button" class="pt-tier" data-n="' + t.n + '">' +
        '<span class="pt-hex"><span class="pt-hex__n">' + t.n + '</span></span>' +
        '<span class="pt-tier__price">' + t.price + '</span>' +
        (t.gift ? '<span class="pt-tier__gift">' + t.gift + '</span>' : '') +
        '</button>';
    }).join('<span class="pt-tier__dash" aria-hidden="true"></span>');
    var b = document.createElement("div");
    b.className = "pt-banner";
    b.innerHTML =
      '<div class="pt-banner__head">' +
        '<h2 class="pt-banner__title">Build Your Box &mdash; Bundle &amp; Save</h2>' +
        '<p class="pt-banner__sub">Pick a pack size, fill it with your favourites &mdash; ' +
        'or hit <strong>Random Fill</strong> for a surprise.</p>' +
      '</div>' +
      '<div class="pt-tiers">' + tiers + '</div>';
    wrap.insertBefore(b, wrap.firstChild);
    b.querySelectorAll(".pt-tier").forEach(function (btn) {
      btn.addEventListener("click", function () {
        setGoal(parseInt(btn.getAttribute("data-n"), 10));
      });
    });
  }

  function buildControls() {
    var f = document.querySelector(".gbbBundleFooter");
    if (!f || f.querySelector(".pt-goal")) return;
    var g = document.createElement("div");
    g.className = "pt-goal";
    g.innerHTML =
      '<div class="pt-goal__row">' +
        '<span class="pt-goal__label">Your pack</span>' +
        '<span class="pt-goal__count">Pick a pack size</span>' +
      '</div>' +
      '<div class="pt-goal__bar"><span></span></div>' +
      '<button type="button" class="pt-fill" disabled>Choose a pack size above</button>';
    f.insertBefore(g, f.firstChild);
    g.querySelector(".pt-fill").addEventListener("click", mysteryFill);
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () {
      pending = false;
      try { buildBanner(); buildControls(); hideMysteryTile(); renderGoal(); } catch (e) {}
    }, 100);
  }

  // Make the whole Build-a-Box area use the SAME fonts as the rest of the site
  // (EBB ships its own font; the theme is Poppins headings / Inter body). Force
  // every bundle element onto the theme body font, titles onto the heading font.
  function ensureFontStyle() {
    if (document.getElementById("pt-font-style")) return;
    var s = document.createElement("style");
    s.id = "pt-font-style";
    s.textContent =
      ".gbbBundleWrapper,.gbbFullPageBundle{font-family:var(--font-body-family,inherit)}" +
      ".gbbBundleWrapper *,.gbbFullPageBundle *,.pt-banner *,.pt-goal *{font-family:inherit !important}" +
      ".pt-banner__title,.pt-cat-head,.gbbCategoryTabTitle,.gbbProductTitle{font-family:var(--font-heading-family,inherit) !important}";
    document.head.appendChild(s);
  }

  function start() {
    var root = document.querySelector(".gbbBundleWrapper") ||
               document.querySelector(".gbbFullPageBundle");
    if (!root) { setTimeout(start, 400); return; }
    ensureFontStyle();
    buildBanner(); buildControls(); hideMysteryTile(); renderGoal();
    new MutationObserver(schedule).observe(root, {
      childList: true, subtree: true, characterData: true
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
